import { Quill } from 'react-quill';
// @ts-ignore
import videoExtensions from 'video-extensions';
// @ts-ignore
import audioExtensions from 'audio-extensions';
// @ts-ignore
import imageExtensions from '@mylinkpi/image-extensions';
import { equals, find } from 'ramda';
import generateId from '../shared/infrastructure/id-generation/generate-id';

const EmbedBlot = Quill.import('blots/embed');

class FileBlot extends EmbedBlot {
  private blotId = generateId();
  private enableSetting = false;
  private enableDownload = false;
  private downloadDom: HTMLElement | null = null;
  private settingDom: HTMLElement | null = null;

  constructor(domNode: HTMLElement) {
    super(domNode);
    this.downloadDom = domNode.querySelector('.file-dl');
    this.settingDom = domNode.querySelector('.file-st');

    if (this.settingDom) {
      this.settingDom.onclick = () => {
        const is = this.getQuill();
        if (!is) return;
        is.setFileBlotScopeAuth(this.value().fileBlot, domNode);
        // domNode.setAttribute('scopeDownloadAuth', 'true');
      };
    }
  }

  static create(value: {
    href: string;
    fileName: string;
    fileSize: number;
    fileType: string;
    scopeDownloadAuth: boolean | undefined;
  }) {
    let node = super.create();
    node.setAttribute('href', value.href);
    node.setAttribute('name', value.fileName);
    node.setAttribute('size', value.fileSize);
    node.setAttribute('type', value.fileType);
    node.setAttribute('contenteditable', 'true');
    node.setAttribute('scopeDownloadAuth', value.scopeDownloadAuth);

    const downloadDom = document.createElement('a');
    downloadDom.className = 'file-dl';
    downloadDom.title = '点击下载';
    downloadDom.download = 'true';
    downloadDom.onclick = function () {
      window.open(value.href);
    };
    let dlIcon = document.createElement('i');
    dlIcon.className = 'iconfont iconDownload ';
    downloadDom.appendChild(dlIcon);
    let fileInfo = document.createElement('span');
    fileInfo.className = 'file-disable';
    let fileSize = document.createElement('span');
    fileSize.className = 'file-size';
    if (value.fileSize === null) {
      fileSize.innerText = '';
    } else {
      fileSize.innerText =
        Math.ceil(value.fileSize / 1024) > 1024
          ? Math.round(value.fileSize / 1024 / 1024) + 'MB'
          : Math.ceil(value.fileSize / 1024) + 'KB';
    }

    let typeIcon = document.createElement('img');
    let typeClass = 'file-type';
    let src = getTypeImg(value);
    typeIcon.className = typeClass;
    typeIcon.src = src;
    let fileName = document.createElement('span');
    fileName.className = 'file-name';
    fileName.innerText = decodeURI(value.fileName);
    fileInfo.setAttribute('title', decodeURI(value.fileName));

    fileInfo.appendChild(typeIcon);
    fileInfo.appendChild(fileName);
    fileInfo.appendChild(fileSize);

    const settingDom = document.createElement('span');
    settingDom.className = 'file-st';
    const settingIcon = document.createElement('i');
    settingIcon.className = 'iconfont iconproperty_more ';
    settingDom.appendChild(settingIcon);
    Object.assign(settingDom.style, {
      color: '#316EF5',
      marginLeft: '10px',
      cursor: 'pointer',
      display: 'none',
    });

    const wrapper = document.createElement('div');
    const inner = document.createElement('div');
    wrapper.append(inner);
    node.appendChild(wrapper);

    wrapper.className = 'ql-file-wrapper';
    inner.className = 'ql-file-inner';
    wrapper.setAttribute('contenteditable', 'false');
    inner.appendChild(fileInfo);
    inner.appendChild(downloadDom);
    inner.appendChild(settingDom);
    return node;
  }
  static value(node: Element) {
    return {
      href: node.getAttribute('href'),
      fileName: node.getAttribute('name'),
      fileSize: node.getAttribute('size'),
      fileType: node.getAttribute('type'),
      scopeDownloadAuth: getScopeDownloadAuth(node.getAttribute('scopeDownloadAuth')),
    };
  }

  applyAuthDom() {
    if (this.downloadDom) {
      this.downloadDom.style.display = this.enableDownload ? 'block' : 'none';
    }
    if (this.settingDom) {
      this.settingDom.style.display = this.enableSetting ? 'block' : 'none';
    }
  }

  getQuill() {
    let is = null;
    try {
      is = Quill.find(this.attributes.domNode.closest('.ql-container'));
    } catch (error) {}
    return is;
  }

  checkAuth() {
    const is = this.getQuill();
    if (!is) return;
    if (is.getFileBlotAuth) {
      const blotValue = this.value().fileBlot;
      const status = is.getFileBlotAuth();
      this.enableDownload =
        blotValue.scopeDownloadAuth === undefined ? status.download : blotValue.scopeDownloadAuth;
      this.enableSetting = this.enableDownload || status.setting;
    } else {
      this.enableDownload = true;
      this.enableSetting = false;
    }
    this.applyAuthDom();
  }

  // 把所有file blot都挂载到所在的Quill对象上
  // 需要更新的时候 在外部通过Quill去调用
  attach() {
    super.attach();
    const is = this.getQuill();
    if (!is) return;
    if (!is.fileBlots) {
      is.fileBlots = {};
    }
    is.fileBlots[this.blotId] = this;

    // 验证一次
    this.checkAuth();
  }

  detach() {
    super.detach();
    const is = this.getQuill();
    if (!is) return;
    delete is.fileBlots[this.blotId];
  }
}
FileBlot.blotName = 'fileBlot';
FileBlot.className = 'ql-file';
FileBlot.tagName = 'p';

const getScopeDownloadAuth = (auth: string | null) => {
  return { undefined: undefined, true: true, false: false }[auth || 'undefined'];
};

export type FileIconTypes =
  | 'image'
  | 'video'
  | 'audio'
  | 'excel'
  | 'pdf'
  | 'doc'
  | 'ppt'
  | 'file'
  | 'zip'
  | 'unknown';
export const FileExtentionConfig: {
  ext: string[];
  type: FileIconTypes;
  src: string | Function;
}[] = [
  {
    ext: imageExtensions,
    type: 'image',
    src: (url: string) => url,
  },
  {
    ext: videoExtensions,
    type: 'video',
    src: 'video.png',
  },
  {
    ext: audioExtensions,
    type: 'audio',
    src: 'audio file.png',
  },
  {
    ext: ['rar', 'zip', 'gz', 'z', '7z'],
    type: 'zip',
    src: 'zip.png',
  },
  {
    ext: ['xls', 'xlsx'],
    type: 'excel',
    src: 'excel.png',
  },
  {
    ext: ['doc', 'docx'],
    type: 'doc',
    src: 'word.png',
  },
  {
    ext: ['ppt', 'pptx'],
    type: 'ppt',
    src: 'ppt.png',
  },
  {
    ext: ['pdf'],
    type: 'pdf',
    src: 'pdf.png',
  },
];
const getTypeImg = (value: { fileType: string }) => {
  const fileType = value.fileType;
  let src = 'https://www.mylinkpi.com/icon/';
  let type: FileIconTypes = 'unknown';
  for (let index = 0; index < FileExtentionConfig.length; index++) {
    const config = FileExtentionConfig[index];
    if (find(equals(fileType))(config.ext)) {
      type = config.type;
      // FIXME: 硬编码
      if (type === 'image') {
        src += 'img.png';
      } else {
        src += config.src;
      }
      break;
    }
  }

  if (type === 'unknown') {
    src += 'unknown file.png';
  }

  return src;
};

export default FileBlot;
